// extracted by mini-css-extract-plugin
module.exports = {"dotMenu":"SpouseAccountPopOver-module__dotMenu--2LCIl","dotsIcon":"SpouseAccountPopOver-module__dotsIcon--1-ohQ","popoverMenu":"SpouseAccountPopOver-module__popoverMenu--12yLq"};